import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=8185e80e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=8185e80e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8185e80e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8185e80e')) {
      api.createRecord('8185e80e', component.options)
    } else {
      api.reload('8185e80e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=8185e80e&scoped=true&", function () {
      api.rerender('8185e80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lzx6Yoi3EHt2/JS/comp/GuestBox.vue"
export default component.exports